import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import FilterButtons from "../../../components/FilterButtons";

import {
  SystemCodeMultipleSelect,
  SystemCodeSelect,
  VehicleSelect
} from "../../../components/inputs";

function VehicleFilters({ filters, onFilter, onClose, resetFilters }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = useCallback(
    e => {
      const updates = { ...inputs };

      if (e.value && !e.target && e.name) {
        if (e.name === "StatusRecIdRef_in") {
          const currSelected = [...updates.StatusRecIdRef_in];
          const currIndex = currSelected.indexOf(parseInt(e.value));
          if (currIndex > -1) {
            currSelected.splice(currIndex, 1);
          } else {
            currSelected.push(parseInt(e.target.value));
          }
          updates[e.name] = currSelected;
        }
      } else {
        updates[e.target.name] = e.target.value;
      }
      setInputs(prev => ({ ...prev, ...updates }));
    },
    [inputs]
  );

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(resetFilters());

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <VehicleSelect
            firstOptionEnabled
            orderByNumber
            icon="globe"
            label="Vehicle"
            name="RecId"
            showHelp={false}
            value={inputs.RecId}
            onChange={handleChange}
          />
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Vehicle Number</Label>
              <Input
                name="VehicleNumber_contains"
                type="text"
                value={inputs.VehicleNumber_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Vehicle Description</Label>
              <Input
                name="Description_contains"
                type="text"
                value={inputs.Description_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Field>
            <Control expanded>
              <SystemCodeSelect
                icon="truck"
                label="Vehicle Type"
                lookup={{ Category: "Fleet", Code: "VehicleType" }}
                name="VehicleTypeRecIdRef"
                showHelp={false}
                value={inputs.VehicleTypeRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>

        <Column>
          <Field>
            <Control expanded>
              <SystemCodeMultipleSelect
                label="Status"
                lookup={{
                  Category: "Fleet",
                  Code: "VehicleStatus"
                }}
                name="StatusRecIdRef_in"
                value={inputs.StatusRecIdRef_in || []}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}

VehicleFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  resetFilters: PropTypes.func
};
export default VehicleFilters;
